<script setup lang="ts">
import type { NuxtLocale } from '~/constants/locales'

const { t } = useI18n()
const localePath = useLocalePath()

const route = useRoute()
watch(
  () => route.params.slug,
  () => {
    useSeoMeta({
      title: t('pages.product-lines.meta.title'),
      description: t('pages.index.meta.description'),
    })
  },
  { immediate: true }
)

// definePageMeta({
//   scrollToTop: false,
// })

const productsRepository = createProductsRepository()

const {
  data: category,
  error,
  status,
  execute,
} = await useLazyAsyncData(
  'product-lines' + route.params.slug,
  () => productsRepository.getCategoryBySlug(route.params.slug),
  {
    immediate: false,
  }
)

watchEffect(async () => {
  if (
    error.value &&
    (isProductLinesCategoryPage.value || isProductLinesPage.value)
  ) {
    const { data: translatedSlug } = await useAsyncData(() =>
      productsRepository.translateCategorySlug(route.params.slug)
    )

    if (translatedSlug.value) {
      navigateTo(
        localePath({
          name: 'product-lines-category-slug',
          params: { slug: translatedSlug.value.urlSlug },
        })
      )
    } else {
      throw createError({ statusCode: 404, message: t('error.pageNotFound') })
    }
  }
})

function isCurrentPage(searchString: string) {
  return route.name?.toString().startsWith(searchString)
}

const isProductLinesPage = computed(() => isCurrentPage('product-lines___'))

const isProductLinesCategoryPage = computed(() =>
  isCurrentPage('product-lines-category-slug___')
)

if (isProductLinesCategoryPage.value || isProductLinesPage.value) {
  await useLazyAsyncData(() => execute())
}

watch(
  () => route.params.slug,
  async () => {
    if (isProductLinesCategoryPage.value || isProductLinesPage.value) {
      await useLazyAsyncData(() => execute())
    }
  }
)
</script>

<template>
  <main>
    <UiBanner
      :title="$t('pages.product-lines.label')"
      v-if="isProductLinesPage"
    />
    <UiBanner
      :title="category?.title ?? ''"
      :slug="category?.title ?? undefined"
      :overrides="[undefined, undefined, false, undefined]"
      v-else-if="isProductLinesCategoryPage"
    />
    <ProductLinesProductCategoryPicker
      v-if="isProductLinesCategoryPage || isProductLinesPage"
    />
    <section
      class="bg-neutral-100 px-10 pb-10 lg:px-24"
      v-if="isProductLinesPage"
    >
      <ProductLinesOverview />
    </section>
    <NuxtPage :category="category" :status="status" />
    <UiContactUs class="mt-10" />
  </main>
</template>
